import { render, staticRenderFns } from "./a-loader-h2h.vue?vue&type=template&id=55285616"
import script from "./a-loader-h2h.vue?vue&type=script&lang=js"
export * from "./a-loader-h2h.vue?vue&type=script&lang=js"
import style0 from "./a-loader-h2h.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports